import { SessionAppState } from './types';
import { apiGetBundle } from '../cmx/api';

export const getPersonId = ({ session }: SessionAppState) => session.accessTokenPayload && session.accessTokenPayload.person_id || '';
export const getCompanyId = ({ session }: SessionAppState) => session.accessTokenPayload && (session.accessTokenPayload.cmp) || '';
// export const getFirstName = ({ session }: SessionAppState) => session.claims && session.claims.given_name || '';
// export const getLastName = ({ session }: SessionAppState) => session.claims && session.claims.family_name || '';
// export const getFullName = ({ session }: SessionAppState) => session.claims && session.claims.name || '';
export const getUserAuthenticated = ({ session }: SessionAppState) => !!session.authState.accessToken;
// export const getUserCountryCode = ({ session }: SessionAppState) => session.claims && session.claims.country || '';
// export const getUserEmail = ({ session }: SessionAppState) => {
//     const emails = session.claims && session.claims.email || {};
//     return emails[ Object.keys( emails )[ 0 ] ] || '';
// };
export const getSessionId = ({ session }: SessionAppState) =>
    session.authState.delegate.access_token || session.authState.access_token;
export const getClaims = ({ session }: SessionAppState) => session.authState.claims;
export const getLocale = ({ session }: SessionAppState) => session.locale;
export const isAuthenticated = (state: SessionAppState) => Boolean(getSessionId(state));

export const getDelegatedCompanyId = ({ session }: SessionAppState): undefined | null | string | void => {
    session.delegateCompanyId;
};

export const getDelegatedOrCurrentCompanyId = ({ session }: SessionAppState) =>
    session.delegateCompanyId || (session.authState.claims && session.authState.claims.company_id);

export const isDelegatingToAnotherCompany = ({ session }: SessionAppState): boolean =>
    session.delegateCompanyId !== undefined &&
    session.delegateCompanyId !== null &&
    session.delegateCompanyId !== session.authState.claims.company_id;

export const hasPermission = (app: string, permission: string) =>
    ({ session }: SessionAppState) =>
        (session.accessTokenPayload && session.accessTokenPayload.permissions[app] || []).includes(permission);


export const getNavigationBundle = async () => {
    const response = await apiGetBundle('navigation');
    return response;
};
